export const CHANNEL_HAIRLINE = 'Channel';
export const DISTANCE_HAIRLINE = 'Distance';
export const EVENT_HAIRLINE = 'Event';
export const TRIGGER_HAIRLINE = 'Trigger';
export const ADVANCED_SEARCH_HAIRLINE = 'Advanced Search';

export const FIXED_HAIRLINE_TYPES = [TRIGGER_HAIRLINE, EVENT_HAIRLINE, ADVANCED_SEARCH_HAIRLINE];
